import Matter from "matter-js";
import { EventBus } from "../../core/event-bus.js";
import {
  applyFlaskWallSlideGlance,
  enforceMouthEscapeContainment,
  shouldIgnoreMouthGateCollision,
} from "./containment.js";
import { isBodyMerging, queueMergeMotion } from "./merge-motion.js";
import { finishFlaskDropLanding } from "./bodies.js";

function isMouthSealBody(system, body) {
  if (!system || !body) return false;
  if (system.mouthSealBody && body.id === system.mouthSealBody.id) return true;
  var seals = system.mouthSealBodies;
  if (!seals) return false;
  for (var i = 0; i < seals.length; i++) {
    if (seals[i] && seals[i].id === body.id) return true;
  }
  return false;
}

function maybeFinishDropLanding(meta, other, system) {
  if (!meta || !meta._dropLanding) return;
  if (isMouthSealBody(system, other)) return;
  finishFlaskDropLanding(meta);
}

export function attachCollisionHandlers(system) {
  var Events = Matter.Events;
  var pendingMerges = [];

  Events.on(system.engine, "collisionStart", function (event) {
    var pairs = event.pairs;
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i];
      if (shouldIgnoreMouthGateCollision(system, pair)) {
        pair.isActive = false;
        continue;
      }
      var a = pair.bodyA;
      var b = pair.bodyB;
      var metaA = system.bodiesMap[a.id];
      var metaB = system.bodiesMap[b.id];
      maybeFinishDropLanding(metaA, b, system);
      maybeFinishDropLanding(metaB, a, system);
      var hasFlaskBody = !!metaA || !!metaB;
      if (!hasFlaskBody) continue;

      var isSameTierPair = !!metaA && !!metaB && metaA.tier === metaB.tier;
      if (isSameTierPair) {
        // Stop solver friction while the pair is queued — avoids ball–ball clumping before merge motion.
        pair.isActive = false;
        var tier = metaA.tier;
        var nextTier = tier + 1;
        var canUpgradeTier = nextTier < system.evolutionChain.length;
        var mx = (a.position.x + b.position.x) / 2;
        var my = (a.position.y + b.position.y) / 2;
        pendingMerges.push({
          a: a,
          b: b,
          metaA: metaA,
          metaB: metaB,
          tier: tier,
          nextTier: nextTier,
          canUpgradeTier: canUpgradeTier,
          mx: mx,
          my: my,
        });
        continue;
      }

      var now = Date.now();
      if (now - system.lastImpactSoundAt < 80) continue;
      system.lastImpactSoundAt = now;
      if (EventBus && EventBus.emit) {
        EventBus.emit("flask:impact", {});
      }
    }
  });

  Events.on(system.engine, "collisionActive", function (event) {
    var pairs = event.pairs;
    var wallIds = system._flaskWallIds;
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i];
      if (shouldIgnoreMouthGateCollision(system, pair)) {
        pair.isActive = false;
        continue;
      }
      if (!wallIds || !pair.collision) continue;
      var a = pair.bodyA;
      var b = pair.bodyB;
      var cargo = null;
      var wall = null;
      var meta = null;
      if (a.isStatic && wallIds[a.id] && system.bodiesMap[b.id]) {
        wall = a;
        cargo = b;
        meta = system.bodiesMap[b.id];
      } else if (b.isStatic && wallIds[b.id] && system.bodiesMap[a.id]) {
        wall = b;
        cargo = a;
        meta = system.bodiesMap[a.id];
      }
      if (meta && cargo && wall) {
        applyFlaskWallSlideGlance(meta, cargo, wall, pair.collision);
      }
    }
  });

  Events.on(system.engine, "afterUpdate", function () {
    enforceMouthEscapeContainment(system, "post");
    for (var i = 0; i < pendingMerges.length; i++) {
      var m = pendingMerges[i];
      if (isBodyMerging(system, m.a.id) || isBodyMerging(system, m.b.id)) continue;
      queueMergeMotion(system, m);
    }
    pendingMerges.length = 0;
  });
}